import {useInfiniteQuery} from "react-query";
import {getEventListApi} from "../../../api/ClientApi";

const useEvents = (queryKey) => {
    const fetchList = async (pageParam = 1) => {
        try {
            let res = await getEventListApi({page: pageParam, limit: 10, plan_id: 0});
            let data = res?.data?.data;
            return {
                result: data?.data,
                next: data?.next_page_url != null ? pageParam + 1 : undefined
            }
        } catch (e) {
            // error on get list
        }
    }


    return useInfiniteQuery([queryKey], ({
                                             pageParam = 1,
                                         }) => fetchList(pageParam), {
        getNextPageParam: (lastPage) => lastPage?.next ?? null,
        select: (data) => data,
    });
};

export default useEvents;